import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "../feedback/ConfirmDialog";

const ConfirmDeleteArsenal = ({
  show,
  onHide,
  confirmDescription,
  confirmButtonText,
  onConfirmClick,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      show={show}
      onHide={onHide}
      description={t(
        confirmDescription || "message.confirm.confirmDeleteArsenal",
      )}
      confirmText={t(confirmButtonText || "message.confirm.deleteArsenal")}
      onConfirm={onConfirmClick}
    />
  );
};

export default ConfirmDeleteArsenal;
